export const FIELD_VALIDATOR_REGISTRY = [
    {
        kind: "required",
        displayName: "Required",
        supportedValueTypes: ["string", "number", "boolean", "date", "string[]"],
        duplicateAllowed: false,
        defaultConfig: () => ({}),
    },
    {
        kind: "email",
        displayName: "Email format",
        supportedValueTypes: ["string"],
        duplicateAllowed: false,
        defaultConfig: () => ({}),
    },
    {
        kind: "min",
        displayName: "Minimum value",
        supportedValueTypes: ["number"],
        duplicateAllowed: false,
        defaultConfig: () => ({ value: 0 }),
    },
    {
        kind: "max",
        displayName: "Maximum value",
        supportedValueTypes: ["number"],
        duplicateAllowed: false,
        defaultConfig: () => ({ value: 0 }),
    },
    {
        kind: "minLength",
        displayName: "Minimum length",
        supportedValueTypes: ["string", "string[]"],
        duplicateAllowed: false,
        defaultConfig: () => ({ value: 0 }),
    },
    {
        kind: "maxLength",
        displayName: "Maximum length",
        supportedValueTypes: ["string", "string[]"],
        duplicateAllowed: false,
        defaultConfig: () => ({ value: 0 }),
    },
    {
        kind: "pattern",
        displayName: "Pattern (regex)",
        supportedValueTypes: ["string"],
        duplicateAllowed: true,
        defaultConfig: () => ({ pattern: "", message: "" }),
    },
    {
        kind: "oneOf",
        displayName: "One of (options)",
        supportedValueTypes: ["string", "number"],
        duplicateAllowed: false,
        defaultConfig: () => ({}),
    },
    {
        kind: "eachOneOf",
        displayName: "Each one of (options)",
        supportedValueTypes: ["string[]"],
        duplicateAllowed: false,
        defaultConfig: () => ({}),
    },
    {
        kind: "customRef",
        displayName: "Custom validator",
        supportedValueTypes: ["string", "number", "boolean", "date", "string[]"],
        duplicateAllowed: true,
        defaultConfig: () => ({}),
    },
];
export function getFieldValidatorRegistryEntry(kind) {
    return FIELD_VALIDATOR_REGISTRY.find((entry) => entry.kind === kind);
}
export function isValidatorCompatible(kind, valueType) {
    return getFieldValidatorRegistryEntry(kind)?.supportedValueTypes.includes(valueType) ?? false;
}
export function compatibleValidatorKinds(valueType) {
    return FIELD_VALIDATOR_REGISTRY.filter((entry) => entry.supportedValueTypes.includes(valueType)).map((entry) => entry.kind);
}
export function isDuplicateKindAllowed(kind) {
    return getFieldValidatorRegistryEntry(kind)?.duplicateAllowed ?? true;
}
